export const VAULT_VALUES = {
    accessoriesChevroletPath: "localhost:8087",
    partsChevroletPath: "localhost:8093",
    chevroletPath: "www-chevrolet-com.stage.acp.gm.com",
    accessoriesChevroletStoreId: "11201",
    partsChevroletStoreId: "11701",

    accessoriesBuickPath: "localhost:8083",
    partsBuickPath: "localhost:8091",
    buickPath: "www-buick-com.stage.acp.gm.com",
    accessoriesBuickStoreId: "11202",
    partsBuickStoreId: "11702",

    accessoriesGMCPath: "localhost:8082",
    partsGMCPath: "localhost:8094",
    gmcPath: "www-gmc-com.stage.acp.gm.com",
    accessoriesGMCStoreId: "11203",
    partsGMCStoreId: "11703",

    accessoriesCadillacPath: "localhost:8081",
    partsCadillacPath: "localhost:8092",
    cadillacPath: "www-cadillac-com.stage.acp.gm.com",
    accessoriesCadillacStoreId: "11204",
    partsCadillacStoreId: "11704",

    mobileBreakpoint: "992",

    azureClientIdTargetable: "fc8283cf-244c-4a35-901c-d4456e212324",
    azureAccessTokenBaseUrl: "https://custlogin.pp.gm.com:443",
    azureMobileClientPolicy: "b2c_1a_seamless_mobile_signuporsignin"
};
